import React from 'react';
import { useTranslation } from 'react-i18next';
import { Target, Users, AlertTriangle, CheckCircle } from 'lucide-react';
import { useGetProspectStatsQuery } from '../../store/prospectApi';

const ProspectsStats: React.FC = () => {
  const { t } = useTranslation();
  const { data: stats, isLoading } = useGetProspectStatsQuery();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="bg-white p-6 rounded-xl shadow-sm animate-pulse">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
                <div className="h-3 bg-gray-200 rounded w-1/4"></div>
              </div>
              <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const displayStats = [
    {
      title: t('prospects.stats.totalProspects'),
      value: stats?.total ?? 0,
      icon: Target,
      color: 'bg-gradient-to-r from-blue-500 to-blue-600',
    },
    {
      title: t('prospects.stats.totalIntroduce'),
      value: stats?.introduce ?? 0,
      icon: Users,
      color: 'bg-gradient-to-r from-yellow-500 to-orange-500',
    },
    {
      title: t('prospects.stats.totalFailed'),
      value: stats?.failed ?? 0,
      icon: AlertTriangle,
      color: 'bg-gradient-to-r from-red-500 to-red-600',
    },
    {
      title: t('prospects.stats.totalCompleted'),
      value: stats?.completed ?? 0,
      icon: CheckCircle,
      color: 'bg-gradient-to-r from-green-500 to-emerald-600',
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {displayStats.map((stat, index) => (
        <div key={index} className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">{stat.title}</p>
              <p className="text-2xl font-semibold text-gray-900">{stat.value}</p>
            </div>
            <div className={`p-3 rounded-lg ${stat.color}`}>
              <stat.icon className="w-6 h-6 text-white" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProspectsStats;